import { Box, SxProps, Theme } from "@mui/material";
import { signerAccentBar } from "theme/colors";

interface Props {
  children: React.ReactNode;
  /** Card max width in px. Landing = 600, completion = 520 (per design). */
  maxWidth?: number | string;
  sx?: SxProps<Theme>;
  /**
   * Top accent ribbon fill. Defaults to the purple → coral → amber brand
   * ribbon; the status cards pass a per-status gradient (amber for expired,
   * slate for voided, green for approved, …) so the strip carries the state.
   */
  strip?: string;
}

/**
 * White "Signer Experience" card shell: rounded corners, soft shadow, and the
 * purple → coral → amber accent ribbon across the top. Sits on the existing
 * auth background (unchanged). Holds the invite-landing and completion content.
 */
const SignerCard = ({
  children,
  maxWidth = 520,
  sx,
  strip = signerAccentBar,
}: Props) => {
  return (
    <Box
      sx={{
        width: maxWidth,
        maxWidth: "100%",
        mx: "auto",
        textAlign: "left",
        backgroundColor: "background.paper",
        borderRadius: "18px",
        boxShadow: "0 24px 70px rgba(0,0,0,0.28)",
        overflow: "hidden",
        position: "relative",
        ...sx,
      }}
    >
      <Box aria-hidden sx={{ height: "5px", background: strip }} />
      {children}
    </Box>
  );
};

export default SignerCard;
